import { MeasurementSystem } from 'spw-components/unit-conversion/types';
import {
  FETCH_USER_SUCCEEDED,
  Actions,
  UPDATE_USER_AVATAR_SUCCEEDED,
  SET_MEASUREMENT_SYSTEM,
  CHANGE_MEASUREMENT_SYSTEM,
} from './actions';
import { IUserState, UserInitial } from './types';

const initialState: IUserState = {
  user: {
    ...UserInitial,
  },
  userAvatarTimestamp: Date.now(),
  measurementSystem: MeasurementSystem.imperial,
};

const reducer = (
  state: IUserState = initialState,
  action: Actions
): IUserState => {
  switch (action.type) {
    case CHANGE_MEASUREMENT_SYSTEM:
    case SET_MEASUREMENT_SYSTEM:
      return {
        ...state,
        user: {
          ...state.user,
          settings: {
            ...state.user.settings,
            measurementSystemWeb: action.payload,
          },
        },
      };
    case FETCH_USER_SUCCEEDED:
      return {
        ...state,
        user: action.payload.user,
      };
    case UPDATE_USER_AVATAR_SUCCEEDED:
      return {
        ...state,
        user: {
          ...state.user,
          hasAvatar:
            // set true only if the updated user avatar is for the current user
            state.user.id === action.payload.id
              ? action.payload.hasAvatar
              : state.user.hasAvatar,
          thumbnailS3Path: action.payload.thumbnailS3Path,
        },
        userAvatarTimestamp: Date.now(),
      };
    default:
      return state;
  }
};

export default reducer;
